<script setup>
/**
 * @fileoverview SharePortalLayout — wrapper for all `/share/:shareId/*` routes.
 *
 * Mounts the multi-session console host and dock for share users (same Pinia
 * `consoleSessions` store as the main app). Lab console continues to mount
 * these under AppLayout when authenticated.
 */
import ConsoleSessionsHost from '@/components/console/ConsoleSessionsHost.vue'
import ConsoleSessionDock from '@/components/console/ConsoleSessionDock.vue'
</script>

<template>
  <div class="share-portal-layout min-h-screen">
    <router-view />
    <ConsoleSessionsHost />
    <ConsoleSessionDock />
  </div>
</template>
